/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_TitleInputs */

const cs_client_merge_title = /** @type {(inputs: Client_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sloučit klienty`)
};

const en_client_merge_title = /** @type {(inputs: Client_Merge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge clients`)
};

/**
* | output |
* | --- |
* | "Merge clients" |
*
* @param {Client_Merge_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_title = /** @type {((inputs?: Client_Merge_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_title(inputs)
	return cs_client_merge_title(inputs)
});